export default function Testimonials() {
  const testimonials = [
    {
      quote: 'Deer Point Contracting delivered our 240-unit apartment complex on time and within budget. Their attention to detail and proactive communication made the entire process seamless. We look forward to partnering with them on future developments.',
      name: 'Michael Richardson',
      title: 'VP of Development, Regional Apartment Developer',
    },
    {
      quote: 'The renovation of our memory care facility was handled with exceptional care and professionalism. Deer Point understood the unique needs of our residents and minimized disruption while delivering beautiful, functional spaces that enhance quality of life.',
      name: 'Sarah Thompson',
      title: 'Executive Director, Memory Care Community',
    },
    {
      quote: 'We have worked with Deer Point on multiple senior living renovations across three states. Their expertise in healthcare construction, commitment to safety, and ability to work within occupied facilities is unmatched. They are our go-to contractor.',
      name: 'David Chen',
      title: 'Director of Facilities, Senior Living Operator',
    },
  ];

  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-4">
            What Our Clients Say
          </h2>
          <div className="w-24 h-1 bg-[#C5A55A] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Building lasting relationships through quality work and exceptional service.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 relative"
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 left-8">
                <i className="ri-double-quotes-l text-6xl text-[#C5A55A]"></i>
              </div>

              {/* Quote Text */}
              <p className="text-gray-700 text-sm leading-relaxed mb-8 mt-8">
                {testimonial.quote}
              </p>

              {/* Divider */}
              <div className="w-16 h-1 bg-[#C5A55A] mb-6"></div>

              {/* Author Info */}
              <div>
                <p className="font-bold text-[#1A1A1A] text-base mb-1">
                  {testimonial.name}
                </p>
                <p className="text-gray-600 text-sm">
                  {testimonial.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}